import ConnectyCube from './ConnectyCube';
import type { SAMAChat, XMPPChat } from './ConnectyCube';

const connectycube: ConnectyCube = new ConnectyCube();

connectycube.ConnectyCube = ConnectyCube;

export default connectycube;
export { ConnectyCube };
export * from './types/constants';
export type * from './types';
export type { XMPPChat, SAMAChat };
